/* engine-bridge.svelte.ts generated by Svelte v5.56.5 */
import * as $ from 'svelte/internal/client';
import { REINIT_KEYS } from "../../engine/params";
import { art } from "./params.svelte";

let current = null;

export function getEngine() {
	return current;
}

export function replayDrawing() {
	art.paused = false;
	current?.replay();
}

export function bindEngine(engine) {
	current = engine;

	let last = $.snapshot(art.params);
	let cheap = {};
	let heavy = {};
	let raf = 0;
	let timer;

	const flushCheap = () => {
		raf = 0;
		engine.setParams(cheap);
		cheap = {};
	};

	const flushHeavy = () => {
		engine.setParams(heavy);
		heavy = {};
	};

	$.user_effect(() => {
		const snap = $.snapshot(art.params);

		for (const k of Object.keys(snap)) {
			if (snap[k] !== last[k]) {
				(REINIT_KEYS.has(k) ? heavy : cheap)[k] = snap[k];
			}
		}

		last = snap;

		if (Object.keys(cheap).length && !raf) raf = requestAnimationFrame(flushCheap);

		if (Object.keys(heavy).length) {
			clearTimeout(timer);
			timer = setTimeout(flushHeavy, 250);
		}
	});

	let firstSeed = true;

	$.user_effect(() => {
		const s = art.seed;

		if (firstSeed) {
			firstSeed = false;

			return;
		}

		engine.randomize(s);
	});

	$.user_effect(() => {
		if (art.paused) engine.pause(); else engine.resume();
	});

	return () => {
		cancelAnimationFrame(raf);
		clearTimeout(timer);

		if (current === engine) current = null;
	};
}